import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  //  ###    ###  ##   ##
  //  ## #  # ##  ##   ##
  //  ##  ##  ##  ##   ##
  //  ##      ##   ## ##
  //  ##      ##    ###

  if (document.getElementById('topMv')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars

    const slideItem = document.getElementById('topMv')

    // 各要素を取得
    const slideWrap = slideItem.querySelector('.swiper-wrapper')
    const slideList = slideItem.querySelectorAll('.swiper-slide')
    let slideCount = slideList.length // スライドの数

    const slidePerViewMax = 0 * 3 // ループ表示に必要なスライド数　slidesPerViewの2倍
    // ループに不足するスライドを補充する
    while (slideCount < slidePerViewMax) {
      for (const iterator of slideList) {
        const clone = iterator.cloneNode(true)
        slideWrap.appendChild(clone)
        ++slideCount
      }
    }

    const sliderName = 'topMv'
    const topMvSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（topMvSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      touchRatio: 0.3, // タッチスワイプ感度（0でタッチスワイプ無効）
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },
      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: false, // 操作されたら停止する
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }

  /*
   ######   ######          ##    ##    ###    ##     ##
  ##       ##               ####  ##  ##   ##  ##     ##
   ######  ##       ####### ## ## ## ##     ## ##     ##
        ## ##               ##  #### #########  ##   ##
   ######   ######          ##    ## ##     ##    ###

  ターゲットが走査線に入ったら連動する要素にクラスを当てる
  Intersection Observer APIを使用

  <a href="#hoge" class="js-scrollBg js-scrollBg--hoge"></a>
  <section id="hoge" class="js-scrollBg-trigger" data-nav-target="hoge">
    section#hogeが画面に入ったらjs-scrollBg--hogeにクラスを当てる
  </section>
  */

  if (document.getElementsByClassName('js-scrollBg')[0]) {
    scrollNav()
  }
  function scrollNav() {
    const navItems = document.getElementsByClassName('js-scrollBg')
    const intObsOption = {
      rootMargin: '-50% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(scrollNavCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-scrollBg-trigger')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function scrollNavCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        // 接触アイテムを発見
        if (entry.isIntersecting) {
          // 全ての.activeを外す
          for (let index = 0; index < navItems.length; index++) {
            navItems[index].classList.remove('active')
          }
          const entryItem = entry.target
          const target = entryItem.dataset.navTarget // 制御対象名を取得

          // 対象アイテムをアクティブにする
          const targetItems = document.getElementsByClassName('js-scrollBg--' + target)
          for (let index = 0; index < targetItems.length; index++) {
            const targetItem = targetItems[index]
            targetItem.classList.add('active')
          }
          break // 以降の判定は飛ばす
        }
      }
    }
  }
}
